import { v4 as uuid } from 'uuid'

export default {
	namespaced: true,
	state: {
		modal: null,
		modalId: null
	},
	getters: {
		modal: state => state.modal,
		modalId: state => state.modalId,
		isOpen: state => Boolean(state.modal)
	},
	mutations: {

	},
	actions: {
		open: ({state}, [component, props = {}]) => {
			state.modal = {component, props},
			state.modalId = uuid()
		},
		close: ({state}) => state.modal = null
	}
}
